module.exports = __webpack_public_path__ + "src/assets/img/status-green.f55360f6.svg";